import React from "react";
import { Box } from "@mui/material";
const MainLogo = ({ sx, ...props }) => {
  return (
    <Box
      sx={{
        width: 100,
        height: "auto",
        flexDirection: "column",
        alignItems: "flex-start",
        ...sx,
      }}
    >
      <img
        src={props.mainLogo}
        alt="AI4AI Logo"
        style={{ maxWidth: "100%", height: "auto" }}
      />
    </Box>
  );
};

export default MainLogo;
